import React from "react";
import "./styles.scss";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Navigation, Pagination } from "swiper/modules";

const ProductSlider = (props) => {
  const { data } = props;
  return (
    <Swiper
      navigation={true}
      modules={[Navigation, Pagination]}
      pagination={true}
      className="mySwiper-container"
    >
      {data?.map((item, index) => {
        return (
          <SwiperSlide>
            <img src={item} alt={`carousel ${index}`} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default ProductSlider;
